import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from "@ngx-translate/core";
import { InMemoryWebApiModule } from "angular-in-memory-web-api";
import "hammerjs";
import { APP_ROUTES } from "app/app.routes";
import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import {
    FuseProgressBarModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
} from "@fuse/components";
import { fuseConfig } from "app/fuse-config";
import { AppComponent, appInitializerFactory } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { HomeModule } from "app/main/module/sterilwize/home/home.module";
import { PatientModule } from "app/main/module/sterilwize/patient/patient.module";
import { AlertModule } from "app/main/module/sterilwize/alert/alert.module";
import { LabelModule } from "app/main/module/sterilwize/label/label.module";
import { LoginModule } from "app/main/module/auth/login/login.module";
import { RegisterModule } from "app/main/module/auth/register/register.module";
import { ForgotPasswordModule } from "app/main/module/auth/forgot-password/forgot-password.module";
import { environment } from "../environments/environment";
import { AuthenticationService } from "./main/module/common/service/authentication.service";
import { AuthGuard } from "./main/module/auth/auth.guard";

import { RangesFooterComponent } from "./ranges-footer/ranges-footer.component";
import { AsapMaterialModule } from "./material-module";
import { StorageService } from "./main/module/common/service/storage.service";
import { AnalyticsService } from "./main/module/sterilwize/home/analytics.service";
import { NgxMatDrpModule } from "ngx-mat-daterange-picker";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ReactiveFormsModule } from "@angular/forms";
import { SatDatepickerModule, SatNativeDateModule } from "saturn-datepicker";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CassetteModule } from "./main/module/sterilwize/cassette/cassette.module";
import { LoadModule } from "./main/module/sterilwize/load/load.module";
import { TeamModule } from "./main/module/sterilwize/team/team.module";
import { ReportModule } from "./main/module/sterilwize/report/report.module";
import { DashboardModule } from "./main/module/sterilwize/dashboard/dashboard.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatGridListModule } from "@angular/material/grid-list";
import { MaintenanceComponent } from "./main/module/auth/maintenance/maintenance.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTableModule } from "@angular/material/table";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
    MatNativeDateModule,
} from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { Globals } from "./main/module/common/global";
import { ApiService } from "./main/module/common/service/api.service";
import { PiModule } from "./main/module/sterilwize/pi/pi.module";
import { ReportService } from "./main/module/sterilwize/report/report.service";
import { EmailModule } from "./main/module/sterilwize/email/Email.module";
import { SuccessfulComponent } from "./main/module/sterilwize/patient/successful/successful.component";
import { TeamComponent } from "./main/module/sterilwize/team/team.component";
import { SharedModule } from "./main/module/common/shared.module";
import { ScrollableDirective } from "./main/module/common/pagination/scrollable.directive";
import { LoadingSpinnerComponent } from "./main/module/common/pagination/loading-spinner/loading-spinner.component";
import { CommonModule } from "@angular/common";
import { LogsModule } from "./main/module/sterilwize/logs/logs.module";
import { LabModule } from "./main/module/sterilwize/lab/lab.module";
import { RcenterModule } from "./main/module/sterilwize/rcenter/rcenter.module";
import { MaintenanceModule } from "./main/module/sterilwize/maintenance/maintenance.module";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
    APP_DATE_FORMATS,
    AppDateAdapter,
} from "./main/module/sterilwize/report/format-datepicker";
import { CaseModule } from "./main/module/sterilwize/Cases/cases.module";
import { TicketModule } from "./main/module/sterilwize/Tickets/tickets.module";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        RangesFooterComponent,
        MaintenanceComponent,
        SuccessfulComponent,
        ScrollableDirective,
        LoadingSpinnerComponent,
    ],
    imports: [
        // AngularFireAuthModule,
        // AngularFireModule.initializeApp(),
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(APP_ROUTES, {
            onSameUrlNavigation: "reload",
        }),
        AsapMaterialModule,
        // InMemoryWebApiModule.forRoot(FakeDbService, {
        //     delay: 0,
        //     passThruUnknownUrl: true
        // }),
        NgxDaterangepickerMd.forRoot(),
        // AngularFireFunctionsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatTableModule,
        MatGridListModule,
        NgxMatSelectSearchModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        SatDatepickerModule,
        SatNativeDateModule,
        NgxMatDrpModule,

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FlexLayoutModule,
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        HomeModule,
        PatientModule,
        AlertModule,
        LabelModule,
        RcenterModule,
        PiModule,
        LoginModule,
        RegisterModule,
        ForgotPasswordModule,
        CassetteModule,
        LoadModule,
        LogsModule,
        TeamModule,
        ReportModule,
        DashboardModule,
        EmailModule,
        CommonModule,
        LabModule,
        CaseModule,
        MaintenanceModule,
        TicketModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: "en",
        }),
    ],

    entryComponents: [SuccessfulComponent],
    exports: [SuccessfulComponent],
    providers: [
        AuthenticationService,
        ApiService,
        AuthGuard,
        StorageService,
        Globals,
        AnalyticsService,
        ReportService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService],
            multi: true,
        },
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        {
            provide: MAT_DATE_LOCALE,
            useFactory: () => localStorage.getItem("language") || "en",
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
